// GlassSelect — shared single-select glass dropdown. Prefix: qgs-.
// A 1:1 port of the learning-path filter dropdown (frosted pill trigger + popover
// listbox) generalized into a reusable library primitive. Aggregated once via
// libraryStyles.
export const glassSelectStyles = `
  .qgs {
    position: relative;
  }
  .qgs-btn {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    font-family: var(--font-sans);
    font-size: var(--fs-base);
    font-weight: 700;
    color: var(--brand-dark);
    cursor: pointer;
    padding: 9px 14px;
    border-radius: var(--rad-catchup-full);
    border: 1px solid var(--glass-flat-border);
    background: var(--glass-flat-bg);
    -webkit-backdrop-filter: var(--glass-flat-filter);
    backdrop-filter: var(--glass-flat-filter);
    box-shadow: var(--glass-flat-edge), inset 0 1px 1px rgba(255, 255, 255, 0.6);
    transition: box-shadow 0.18s var(--ease-standard),
      border-color 0.18s var(--ease-standard);
  }
  .qgs-btn:hover {
    border-color: var(--brand-light);
  }
  .qgs-btn.is-open {
    border-color: #54bbcb;
    box-shadow: 0 0 0 3px rgba(87, 194, 211, 0.18);
  }
  .qgs-chev {
    transition: transform 0.18s var(--ease-standard);
    flex-shrink: 0;
  }
  .qgs-btn.is-open .qgs-chev {
    transform: rotate(180deg);
  }
  .qgs-menu {
    position: absolute;
    z-index: 60;
    top: calc(100% + 6px);
    left: 0;
    min-width: 100%;
    white-space: nowrap;
    display: flex;
    flex-direction: column;
    gap: 2px;
    padding: 6px;
    border-radius: var(--rad-catchup-large);
    background: var(--glass-popover-bg);
    -webkit-backdrop-filter: var(--glass-popover-filter);
    backdrop-filter: var(--glass-popover-filter);
    border: 1px solid var(--glass-flat-border);
    box-shadow: var(--glass-popover-shadow);
    animation: qgs-in 0.16s var(--ease-standard);
  }
  @keyframes qgs-in {
    from {
      opacity: 0;
      transform: translateY(-6px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  .qgs-opt {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--space-4);
    width: 100%;
    text-align: left;
    cursor: pointer;
    border: none;
    background: transparent;
    font-family: var(--font-sans);
    font-size: var(--fs-base);
    font-weight: 700;
    color: var(--text-secondary);
    padding: 9px 12px;
    border-radius: var(--rad-catchup-medium);
    transition: background 0.15s, color 0.15s;
  }
  .qgs-opt:hover {
    background: var(--glass-active-bg);
    color: var(--brand-dark);
  }
  .qgs-opt.is-active {
    color: var(--brand-dark);
    background: var(--glass-active-bg);
  }
  .qgs-check {
    color: var(--brand-dark);
    font-weight: 800;
  }
`;
